export default __webpack_public_path__ + "static/media/ag_12.96a1f0eb.wav";